// src/app/guards/language.guard.ts
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AppService } from 'src/app/app.service';

@Injectable({
    providedIn: 'root'
})
export class LanguageGuard implements CanActivate {
    private validLanguages = ['en', 'ar'];

    constructor(private router: Router, private app: AppService) { }

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        const languageCode = next.params['languageCode'];
        if (this.validLanguages.includes(languageCode)) {
            return true;
        } else {
            this.router.navigate([`/not-found`]);
            return false;
            // this.router.navigate(['/404']);
        }
    }
}
